import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs';

@Component({
    selector: 'medpt-date',
    templateUrl: './date.component.html',
    standalone: false
})
export class DateComponent {
  @Input() field: any = {};
  @Input() form!: FormGroup;

  get isInValid() { return this.form.controls[this.field.uniquename].invalid; }
  get isTouched() { return this.form.controls[this.field.uniquename].touched; }
  get isDirty() { return this.form.controls[this.field.uniquename].dirty; }

  constructor() {

  }

  onFocus(elm: DatePickerComponent) {
    if (!elm.isOpen) {
      elm.toggle(true);
    }
  }
}



